import {
  GET_ASSESSMENTS,
  PlagiarismActionTypes,
  SET_ASSESSMENTS,
  SET_ASSESSMENT_COMPONENTS,
  SET_REPORT_SUMMARY,
  SET_SEARCH_QUERY,
  GET_ASSESSMENT_COMPONENTS,
  RESET_STATE,
  SET_REPORT_DETAILS,
  SET_REPORT_DETAILS_PARAMS,
  GET_SERIES,
  SET_SERIES,
  SET_PROCESSING_ERRORS_LIST,
} from './types';
import {
  PlagiarismAssessment,
  ProcessingError,
  ReportDetails,
  ReportDetailsParams,
  ReportSummary,
  SearchQuery,
} from '../../types/Plagiarism';
import { EntryComponent, Series } from '@cambridgeassessment/lib-ee-commons';

export const getSeries = (): PlagiarismActionTypes => ({
  type: GET_SERIES,
});

export const setSeries = (seriesData: Series[]): PlagiarismActionTypes => ({
  type: SET_SERIES,
  payload: { seriesData },
});

export const getAssessments = (): PlagiarismActionTypes => ({
  type: GET_ASSESSMENTS,
});

export const setAssessments = (assessments: PlagiarismAssessment[]): PlagiarismActionTypes => ({
  type: SET_ASSESSMENTS,
  payload: { assessments },
});

export const getAssessmentComponents = (): PlagiarismActionTypes => ({
  type: GET_ASSESSMENT_COMPONENTS,
});

export const setAssessmentComponents = (components: EntryComponent[]): PlagiarismActionTypes => ({
  type: SET_ASSESSMENT_COMPONENTS,
  payload: { components },
});

export const setReportSummary = (
  reportSummary: ReportSummary[],
  reportsTotal: number,
  nextPageUrl?: string,
): PlagiarismActionTypes => ({
  type: SET_REPORT_SUMMARY,
  payload: { reportSummary, reportsTotal, nextPageUrl },
});

export const setSearchQuery = (searchQuery: SearchQuery): PlagiarismActionTypes => ({
  type: SET_SEARCH_QUERY,
  payload: { searchQuery },
});

export const resetState = (): PlagiarismActionTypes => ({
  type: RESET_STATE,
});

export const setReportDetails = (
  reportDetails: ReportDetails[],
  reportsDetailsTotal: number,
  nextPageUrl?: string,
): PlagiarismActionTypes => ({
  type: SET_REPORT_DETAILS,
  payload: { reportDetails, reportsDetailsTotal, nextPageUrl },
});

export const setReportDetailsParams = (reportDetailsParams: ReportDetailsParams): PlagiarismActionTypes => ({
  type: SET_REPORT_DETAILS_PARAMS,
  payload: { reportDetailsParams },
});

export const setProcessingErrorsList = (items: ProcessingError[], nextPageUrl?: string): PlagiarismActionTypes => ({
  type: SET_PROCESSING_ERRORS_LIST,
  payload: { items, nextPageUrl },
});

export default {
  getAssessments,
  setAssessments,
  getAssessmentComponents,
  setAssessmentComponents,
  setReportSummary,
  setSearchQuery,
  resetState,
  setReportDetails,
  setSeries,
};
